<h2 mat-dialog-title class="summary">{{ 'ChangePassword.Title' | translate }}</h2>
<mat-dialog-content>
    <form [formGroup]="formGroup">
        <div class="row">
            <div class="col-12">
                <sl-input type="password" placeholderKey="ChangePassword.NewPassword" [control]="formGroup.controls['password']" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <sl-input
                    type="password"
                    placeholderKey="ChangePassword.ConfirmPassword"
                    [control]="formGroup.controls['confirmPassword']" />
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="changePassword()" [disabled]="formGroup.invalid || isSaving" color="primary">
        <mat-icon>save</mat-icon>
        {{ 'General.Save' | translate }}
    </button>
</mat-dialog-actions>
